
import React from "react";
import { Dropdown, Menu } from "antd";
import Logo from '../assets/img/om-icon.png';
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { getUserDetail, logout } from "../util/util";

export const DashboardLayout = (props) => {
  const navigate = useNavigate();
  // Responsive state for mobile nav
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 900);
  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 900);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const logoutUser = () => {
    logout();
    secureLocalStorage.removeItem('expiresAt');
    window.location.href = '/onboard/login';
  };

  return (
    <div>
      <nav className="navbar bg-om-dark navbar-dark">
        <div className="container-fluid" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: 0 }}>
          <div className="navbar-brand" style={{ marginLeft: 14, paddingLeft: 0, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', minWidth: 0 }}>
            <img src={Logo} alt="om-icon" style={{ marginLeft: 14, paddingLeft: 0, width: 50, height: 50, borderRadius: 8 }} />
          </div>
          <div>
            <Dropdown
              overlay={
                <Menu style={{ borderRadius: 12, minWidth: 180, boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
                  <Menu.Divider />
                  <Menu.Item key="logout" onClick={logoutUser} style={{ fontWeight: 600 }}>
                    <i className="bi bi-box-arrow-right me-2" /> Logout
                  </Menu.Item>
                </Menu>
              }
              trigger={["click"]}
              placement="bottomRight"
            >
              <button className='btn btn-white' style={{ display: 'flex', alignItems: 'center' }}>
                <i className="bi bi-person-circle" style={{fontSize:'15px'}} />
                <span className="ms-1">{getUserDetail()?.name}</span>
                <i className="bi bi-caret-down ms-2" style={{fontSize:'12px'}} />
              </button>
            </Dropdown>
          </div>
        </div>
      </nav>
      <div style={{ display: 'flex', width: '100%', minHeight: '100vh', overflow: 'hidden' }}>
        {!isMobile && <CustomSidebar navigate={navigate} logoutUser={logoutUser} />}
        <div style={{ flexGrow: 1, minWidth: 0, display: 'flex', flexDirection: 'column', overflow: 'auto', position: 'relative' }}>
          <div className="omk-bg-secondary padding-general-mobile" style={{ flexGrow: 1, minWidth: 0, overflow: 'auto' }}>
            {props.children}
          </div>
          {isMobile && <MobileBottomNav navigate={navigate} />}
        </div>
      </div>
    </div>
  );
}

// Mobile bottom nav bar: only icons, fixed at bottom, horizontally scrollable
function MobileBottomNav({ navigate }) {
  const menuItems = [
    { label: 'Dashboard', icon: 'dashboard', path: '/dashboard' },
    { label: 'Members', icon: 'People', path: '/dashboard/members' },
    { label: 'Audit Logs', icon: 'database', path: '/dashboard/audit-logs' },
    { label: 'Statements', icon: 'filter', path: '/dashboard/statements' },
    { label: 'Users', icon: 'person', path: '/dashboard/user-management' },
    { label: 'Profile', icon: 'settings', path: '/dashboard/profile' },
    { label: 'Logout', icon: 'power', onClick: () => window.location.href = '/onboard/login' },
  ];
  const currentPath = window.location.pathname;
  return (
    <nav className="mobile-bottom-nav" style={{
      position: 'fixed',
      left: 0,
      bottom: 0,
      width: '100vw',
      background: '#fff',
      borderTop: '1px solid #eee',
      zIndex: 3000,
      display: 'block',
      height: 60,
      boxShadow: '0 -2px 12px rgba(0,0,0,0.04)',
      padding: 0,
      overflowX: 'auto',
      WebkitOverflowScrolling: 'touch',
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        minWidth: '100%',
        width: 'max-content',
        overflowX: 'auto',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        
      }}>
        {menuItems.map((item, idx) => {
          const isActive = currentPath === item.path || (item.path && currentPath.startsWith(item.path));
          return (
            <button
              key={item.label}
              onClick={() => item.onClick ? item.onClick() : navigate(item.path)}
              className="mobile-bottom-nav-btn"
              style={{
                background: 'none',
                border: 'none',
                outline: 'none',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: 70,
                color: isActive ? '#00b050' : '#888',
                fontSize: 11,
                padding: 0,
                height: '100%',
                cursor: 'pointer',
                flex: '0 0 70px',
              }}
              aria-label={item.label}
            >
              <omk-icon slot="nav-icon" style={{ fontSize: 24, color: isActive ? '#00b050' : '#888', marginBottom: 2 }}>{item.icon}</omk-icon>
              <span style={{ fontSize: 10, marginTop: 2 }}>{item.label}</span>
            </button>
          );
        })}
      </div>
      <style>{`
        .mobile-bottom-nav::-webkit-scrollbar { display: none; }
        .mobile-bottom-nav-btn:active { background: #e6f9ed; }
        @media (min-width: 901px) {
          .mobile-bottom-nav { display: none !important; }
        }
      `}</style>
    </nav>
  );
}

// Custom Sidebar component (moved outside DashboardLayout)
function CustomSidebar({ navigate, logoutUser }) {
  const [expanded, setExpanded] = React.useState(false);
  const [hoveredIndex, setHoveredIndex] = React.useState(null);
  const menuItems = [
    { label: 'Dashboard', icon: 'dashboard', path: '/dashboard' },
    { label: 'Members', icon: 'People', path: '/dashboard/members' },
    { label: 'Audit Logs', icon: 'database', path: '/dashboard/audit-logs' },
    { label: 'Statements', icon: 'filter', path: '/dashboard/statements' },
    { label: 'Users', icon: 'person', path: '/dashboard/user-management' },
    { label: 'Profile', icon: 'settings', path: '/dashboard/profile' },
    { label: 'Logout', icon: 'power', onClick: logoutUser },
  ];
  const currentPath = window.location.pathname;
  // Vertical sidebar on the left
  return (
    <div
      style={{
        width: expanded ? 280 : 120,
        background: '#fff',
        borderRight: '1px solid #f0f0f0',
        minHeight: '100vh',
        transition: 'width 0.2s',
        display: 'flex',
        flexDirection: 'column',
        alignItems: expanded ? 'flex-start' : 'center',
        zIndex: 10,
        position: 'relative',
      }}
      className="custom-sidebar shadow-sm"
    >
      {/* Logo */}
      <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: expanded ? 'flex-start' : 'center', padding: expanded ? '8px 18px 4px 18px' : '8px 0 4px 0' }}>
        <img src={Logo} alt="OM Logo" style={{ width: 36, height: 36, borderRadius: 8 }} />
      </div>
      {/* Hamburger above Home */}
      <button
        onClick={() => setExpanded(e => !e)}
        aria-label={expanded ? 'Collapse sidebar' : 'Expand sidebar'}
        style={{
          background: 'none',
          border: 'none',
          outline: 'none',
          cursor: 'pointer',
          margin: expanded ? '0 0 10px 10px' : '0 0 10px 0',
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          fontSize: 24,
          color: '#184b18',
        }}
      >
        <i className="bi bi-list" />
      </button>
      {/* Divider under hamburger (only when collapsed) */}
      {!expanded && (
        <div style={{
          width: '60%',
          height: 1,
          background: '#e0e0e0',
          margin: '0 0 10px 0',
          alignSelf: 'center',
          borderRadius: 1,
        }} />
      )}
      {/* Menu items */}
      <div style={{ width: '100%', marginTop: 8 }}>
        {menuItems.map((item, idx) => {
          const isActive = currentPath === item.path || (item.path !== '/dashboard' && currentPath.startsWith(item.path));
          const isHovered = hoveredIndex === idx;
          return (
            <button
              key={item.label}
              onClick={() => {
                if (item.onClick) item.onClick();
                else navigate(item.path);
              }}
              className="sidebar-menu-btn"
              data-active={isActive ? "true" : undefined}
              onMouseEnter={() => setHoveredIndex(idx)}
              onMouseLeave={() => setHoveredIndex(null)}
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: expanded ? 'row' : 'column',
                alignItems: expanded ? 'flex-start' : 'center',
                textAlign: expanded ? 'left' : 'center',
                gap: expanded ? 14 : 0,
                background: isActive
                  ? 'rgba(0, 200, 83, 0.12)'
                  : isHovered
                    ? '#c3c3c363'
                    : 'none',
                border: 'none',
                outline: 'none',
                padding: expanded ? '12px 18px' : '12px 0',
                fontWeight: 600,
                fontSize: 16,
                color: isActive ? '#184b18' : '#111',
                borderRadius: 18,
                marginBottom: 6,
                justifyContent: 'center',
                transition: 'background 0.2s, color 0.2s',
              }}
              title={item.label}
            >
              <omk-icon slot="nav-icon" style={{ fontSize: 20, flexShrink: 0, color: isActive ? '#000000ff' : '#111' }}>{item.icon}</omk-icon>
              {expanded
                ? <span style={{ flex: 1, alignSelf: 'center', minWidth: 0, color: isActive ? '#000000ff' : '#111' }}>{item.label}</span>
                : <span style={{ fontSize: 13, marginTop: 2, color: isActive ? '#000000ff' : '#111' }}>{item.label}</span>
              }
            </button>
          );
        })}
      </div>
    </div>
  );
}
